(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[595],{

/***/ 7026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ph": function() { return /* binding */ Select; }
/* harmony export */ });
/* unused harmony exports DefaultIcon, SelectField */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3234);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5235);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4520);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2446);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8554);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5__);
// ../../react-shim.js


// src/select.tsx




var SelectField = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function SelectField2(props, ref) {
  const { children, placeholder, className, ...rest } = props;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.select */ .m$.select, {
    ...rest,
    ref,
    className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__.cx)("chakra-select", className)
  }, placeholder && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("option", {
    value: ""
  }, placeholder), children);
});
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .__DEV__ */ .Ts) {
  SelectField.displayName = "SelectField";
}
var Select = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)((props, ref) => {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useMultiStyleConfig */ .jC)("Select", props);
  const {
    rootProps,
    placeholder,
    icon,
    color,
    height,
    h,
    minH,
    minHeight,
    iconColor,
    iconSize,
    ...rest
  } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  const [layoutProps, otherProps] = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .split */ .Vl)(rest, _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .layoutPropNames */ .oE);
  const ownProps = (0,_chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_4__/* .useFormControl */ .Yp)(otherProps);
  const rootStyles = {
    width: "100%",
    height: "fit-content",
    position: "relative",
    color
  };
  const fieldStyles = _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5___default()({ paddingEnd: "2rem" }, styles.field, { _focus: { zIndex: "unset" } });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.div */ .m$.div, {
    className: "chakra-select__wrapper",
    __css: rootStyles,
    ...layoutProps,
    ...rootProps
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectField, {
    ref,
    height: h ?? height,
    minH: minH ?? minHeight,
    placeholder,
    ...ownProps,
    __css: fieldStyles
  }, props.children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectIcon, {
    "data-disabled": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .dataAttr */ .PB)(ownProps.disabled),
    ...(iconColor || color) && { color: iconColor || color },
    __css: styles.icon,
    ...iconSize && { fontSize: iconSize }
  }, icon));
});
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .__DEV__ */ .Ts) {
  Select.displayName = "Select";
}
var DefaultIcon = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
  viewBox: "0 0 24 24",
  ...props
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "currentColor",
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}));
var IconWrapper = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m$)("div", {
  baseStyle: {
    position: "absolute",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    top: "50%",
    transform: "translateY(-50%)"
  }
});
var SelectIcon = (props) => {
  const { children = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DefaultIcon, null), ...rest } = props;
  const clone = (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(children, {
    role: "presentation",
    className: "chakra-select__icon",
    focusable: false,
    "aria-hidden": true,
    style: {
      width: "1em",
      height: "1em",
      color: "currentColor"
    }
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconWrapper, {
    ...rest,
    className: "chakra-select__icon-wrapper"
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(children) ? clone : null);
};
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .__DEV__ */ .Ts) {
  SelectIcon.displayName = "SelectIcon";
}



/***/ }),

/***/ 4995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Textarea; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3234);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5235);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4520);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2446);
// ../../react-shim.js


// src/textarea.tsx



var omitted = ["h", "minH", "height", "minHeight"];
var Textarea = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)((props, ref) => {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useStyleConfig */ .mq)("Textarea", props);
  const { className, rows, ...rest } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .omitThemingProps */ .Lr)(props);
  const textareaProps = (0,_chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_3__/* .useFormControl */ .Yp)(rest);
  const textareaStyles = rows ? (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__/* .omit */ .CE)(styles, omitted) : styles;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.textarea */ .m$.textarea, {
    ref,
    rows,
    ...textareaProps,
    className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-textarea", className),
    __css: textareaStyles
  });
});
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__/* .__DEV__ */ .Ts) {
  Textarea.displayName = "Textarea";
}



/***/ }),

/***/ 2126:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comprar-grama/[province]/[city]",
      function () {
        return __webpack_require__(8912);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AlertComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3038);


function AlertComponent(param) {
    var show = param.show, title = param.title, status = param.status, description = param.description;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: show && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
            position: "fixed",
            top: "0",
            bottom: "0",
            left: "0",
            right: "0",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: "9999",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Alert */ .bZ, {
                status: status,
                variant: "subtle",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                height: "200px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .AlertIcon */ .zM, {
                        boxSize: "40px",
                        mr: 0
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .AlertTitle */ .Cd, {
                        mt: 4,
                        mb: 1,
                        fontSize: "lg",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .AlertDescription */ .X, {
                        maxWidth: "sm",
                        children: description
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 8912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _city_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-input-mask/index.js
var react_input_mask = __webpack_require__(6627);
var react_input_mask_default = /*#__PURE__*/__webpack_require__.n(react_input_mask);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/index.esm.js
var index_esm = __webpack_require__(3234);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var dist_index_esm = __webpack_require__(979);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/select/dist/index.esm.js
var select_dist_index_esm = __webpack_require__(7026);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/textarea/dist/index.esm.js
var textarea_dist_index_esm = __webpack_require__(4995);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var react_hook_form_dist_index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./services/api.ts
var api = __webpack_require__(9419);
;// CONCATENATED MODULE: ./utils/aditionalProducts.js
/* harmony default export */ var aditionalProducts = ([
    {
        "label": "Terra Vermelha p/ cobertura (saco 25 kg)"
    },
    {
        "label": "Terra Preta p/ cobertura (saco 25 kg)"
    },
    {
        "label": "Terra Mista p/ cobertura (saco 25 kg)"
    },
    {
        "label": "Estacas de Bamb\xfa p/ fixa\xe7\xe3o em taludes (1.000 unid)"
    },
    {
        "label": "Calc\xe1rio Dolomitico 40 kg"
    }
]);

;// CONCATENATED MODULE: ./utils/products.js
/* harmony default export */ var products = ([
    {
        label: "Esmeralda"
    },
    {
        label: "Esmeralda Premium"
    },
    {
        label: "Batatais"
    },
    {
        label: "Batatais Plus"
    },
    {
        label: "S\xe3o Carlos"
    },
    {
        label: "S\xe3o Carlos Plus"
    },
    {
        label: "Coreana/Japonesa"
    },
    {
        label: "Bermuda Tifton 419"
    },
    {
        label: "Bermuda Celebration"
    },
    {
        label: "Santo Agostinho/Inglesa"
    }, 
]);

// EXTERNAL MODULE: ./utils/estados.js
var estados = __webpack_require__(3835);
// EXTERNAL MODULE: ./utils/estados-cidades.js
var estados_cidades = __webpack_require__(2487);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var icons_dist_index_esm = __webpack_require__(3382);
// EXTERNAL MODULE: ./components/Layout/Default/index.tsx + 1 modules
var Default = __webpack_require__(7309);
// EXTERNAL MODULE: ./components/Container/index.tsx
var Container = __webpack_require__(1344);
// EXTERNAL MODULE: ./pages/comprar-grama/[province]/styles.ts
var styles = __webpack_require__(3194);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./pages/comprar-grama/index.page.js + 1 modules
var index_page = __webpack_require__(1171);
// EXTERNAL MODULE: ./pages/components/Loading/index.js
var Loading = __webpack_require__(3229);
// EXTERNAL MODULE: ./pages/components/AlertComponent/index.js
var AlertComponent = __webpack_require__(64);
// EXTERNAL MODULE: ./utils/useRecaptcha.js
var useRecaptcha = __webpack_require__(9210);
// EXTERNAL MODULE: ./services/contato.js
var contato = __webpack_require__(2994);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./pages/comprar-grama/[province]/[city].page.js



























var getCorrectName = function(name, province) {
    var correctProvince = estados_cidades/* default.find */.Z.find(function(item) {
        return item.sigla.toLocaleLowerCase() === province;
    });
    var correctName = correctProvince.cidades.find(function(item) {
        return (0,index_page.transformarParaUrlAmigavel)(item) === name;
    });
    return correctName;
};
var Contato = function(param) {
    var province = param.province, city = param.city, seo = param.seo;
    var ref = (0,useRecaptcha/* useRecaptcha */.Z)(), isValid = ref.isValid, reply = ref.reply, question = ref.question;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(false), error = ref2[0], setError = ref2[1];
    var ref3 = (0,react.useState)(false), success = ref3[0], setSuccess = ref3[1];
    var ref4 = (0,react_hook_form_dist_index_esm/* useForm */.cI)({
        defaultValues: {
            state: province,
            city: city
        }
    }), register = ref4.register, handleSubmit = ref4.handleSubmit, getValues = ref4.getValues, setValue = ref4.setValue, reset = ref4.reset, errors = ref4.formState.errors;
    (0,react.useEffect)(function() {
        setValue("city", getCorrectName(city, province));
        setValue("state", province === null || province === void 0 ? void 0 : province.toUpperCase());
    });
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var payload, path, url, emailPayload;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        payload = {
                            "your-email": data.email,
                            "your-name": data.name,
                            userName: data.name,
                            "your-subject": "Or\xe7amento para ".concat(data.name, " de ").concat(data.city, "/").concat(data.state),
                            title: "Or\xe7amento para ".concat(data.name, " de ").concat(data.city, "/").concat(data.state),
                            status: "publish",
                            fields: (0,_object_spread/* default */.Z)({}, data)
                        };
                        _ctx.next = 5;
                        return api/* api.post */.hi.post("/budget", payload);
                    case 5:
                        path = router.asPath;
                        url = "".concat(window.location.protocol, "//").concat(window.location.host).concat(path);
                        emailPayload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload, payload.fields), {
                            url: url
                        });
                        _ctx.next = 10;
                        return (0,contato/* sendBudget */.FO)(emailPayload);
                    case 10:
                        setSuccess(true);
                        setError(false);
                        window === null || window === void 0 ? void 0 : window.scrollTo(0, 0);
                        reset();
                        setTimeout(function() {
                            setSuccess(false);
                        }, 5000);
                        _ctx.next = 22;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](1);
                        setError(true);
                        setSuccess(false);
                        setTimeout(function() {
                            setError(false);
                            setSuccess(false);
                        }, 5000);
                    case 22:
                        _ctx.prev = 22;
                        setLoading(false);
                        return _ctx.finish(22);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    17,
                    22,
                    25
                ]
            ]);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var phone = register("phone");
    var cellphoneRef = register("cellphone");
    var handlePhoneChange = function(e) {
        phone === null || phone === void 0 ? void 0 : phone.onChange(e);
    };
    var handleCelularChange = function(e) {
        cellphoneRef === null || cellphoneRef === void 0 ? void 0 : cellphoneRef.onChange(e);
    };
    var transformToLowerCase = function(value) {
        if (!value) return value;
        return value.toLocaleLowerCase();
    };
    var structuredData = (0,_define_property/* default */.Z)({
        "@context": "https://schema.org/",
        "@type": "Product",
        name: "".concat(seo === null || seo === void 0 ? void 0 : seo.title),
        image: [
            "https://admin.centraldagrama.com/wp-content/uploads/2024/04/entrega-imediata-comprar-grama.webp",
            "https://admin.centraldagrama.com/wp-content/uploads/2024/04/esmeralda-premium-comprar.webp",
            "https://admin.centraldagrama.com/wp-content/uploads/2024/04/grama-placas-esmeralda-premium.webp", 
        ],
        description: "".concat(seo === null || seo === void 0 ? void 0 : seo.description),
        sku: "0446310786",
        mpn: "925872",
        brand: {
            "@type": "Thing",
            name: "ACME"
        },
        review: {
            "@type": "Review",
            reviewRating: {
                "@type": "Rating",
                ratingValue: "5",
                bestRating: "5"
            },
            author: {
                "@type": "Person",
                name: "Robert Pardim"
            }
        },
        aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "5",
            reviewCount: "2183"
        },
        tags: [
            "comprar grama",
            "grama esmeralda",
            "grama batatais",
            "grama s\xe3o carlos",
            "grama bermuda",
            "grama coreana",
            "grama santo agostinho", 
        ],
        offers: {
            "@type": "Offer",
            price: "2.99",
            priceCurrency: "BRL",
            priceValidUntil: "2025-12-31",
            itemCondition: "https://schema.org/NewCondition",
            availability: "https://schema.org/InStock",
            seller: {
                "@type": "Organization",
                name: "Central da Grama"
            }
        }
    }, "review", {
        "@type": "Review",
        author: "Leandro Medeiros",
        datePublished: "2021-04-04",
        reviewBody: "\xd3timo atendimento, entrega r\xe1pida e pre\xe7o justo.",
        name: "\xd3timo atendimento",
        reviewRating: {
            "@type": "Rating",
            ratingValue: "5"
        }
    });
    console.log(seo);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Default/* default */.Z, {
        links: router.asPath,
        category: seo === null || seo === void 0 ? void 0 : seo.h1,
        categorySize: "25px",
        title: seo === null || seo === void 0 ? void 0 : seo.title,
        description: seo === null || seo === void 0 ? void 0 : seo.description,
        keywords: "comprar grama ".concat(transformToLowerCase(getCorrectName(city, province)), " ").concat(province, ", grama para ").concat(transformToLowerCase(getCorrectName(city, province)), " ").concat(province, ", pre\xe7o de grama ").concat(transformToLowerCase(getCorrectName(city, province)), " ").concat(province, ", or\xe7amento de grama ").concat(transformToLowerCase(getCorrectName(city, province)), " ").concat(province, ", m2 de grama em ").concat(transformToLowerCase(getCorrectName(city, province)), " ").concat(province),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredData)
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                        isLoading: loading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertComponent/* default */.Z, {
                        show: success,
                        title: "Formul\xe1rio Enviado",
                        status: "success",
                        description: "Obrigado por entrar e solicitar um or\xe7amento, em breve te retornaremos!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertComponent/* default */.Z, {
                        show: error,
                        title: "Oops",
                        status: "error",
                        description: "Houve um erro ao enviar, tente novamente mais tarde."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Flex */.kC, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Left */.dv, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Preencha o formul\xe1rio abaixo"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Form */.l0, {
                                        onSubmit: handleSubmit(onSubmit),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormControl */.NI, {
                                                isInvalid: errors.name,
                                                mb: "24px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("name", {
                                                        required: "Este campo \xe9 obrigat\xf3rio"
                                                    })), {
                                                        type: "text",
                                                        placeholder: "Nome"
                                                    })),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormErrorMessage */.J1, {
                                                        children: errors.name && errors.name.message
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Grid */.rj, {
                                                gap: "24px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormControl */.NI, {
                                                        isInvalid: errors.email,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("email", {
                                                                required: "Este campo \xe9 obrigat\xf3rio",
                                                                pattern: {
                                                                    value: /\S+@\S+\.\S+/,
                                                                    message: "Digite um email v\xe1lido"
                                                                }
                                                            })), {
                                                                type: "email",
                                                                placeholder: "Email"
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormErrorMessage */.J1, {
                                                                children: errors.email && errors.email.message
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormControl */.NI, {
                                                        isInvalid: errors.confirmarEmail,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("confirmarEmail", {
                                                                validate: function(value) {
                                                                    return value === getValues("email") || "Os emails n\xe3o correspondem";
                                                                }
                                                            })), {
                                                                type: "email",
                                                                placeholder: "Confirme seu email"
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormErrorMessage */.J1, {
                                                                children: errors.confirmarEmail && errors.confirmarEmail.message
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormControl */.NI, {
                                                        isInvalid: errors.state,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(select_dist_index_esm/* Select */.Ph, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("state", {
                                                                required: "Este campo \xe9 obrigat\xf3rio"
                                                            })), {
                                                                placeholder: "state",
                                                                disabled: true,
                                                                children: estados/* default.map */.Z.map(function(item) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: item.sigla,
                                                                        children: item.sigla
                                                                    }, "estado-".concat(item.sigla));
                                                                })
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormErrorMessage */.J1, {
                                                                children: errors.state && errors.state.message
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormControl */.NI, {
                                                        isInvalid: errors.city,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("city", {
                                                                required: "Este campo \xe9 obrigat\xf3rio",
                                                                minLength: {
                                                                    value: 3,
                                                                    message: "O city deve ter pelo menos 3 caracteres"
                                                                }
                                                            })), {
                                                                type: "text",
                                                                placeholder: "city p/ Entrega",
                                                                disabled: true
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormErrorMessage */.J1, {
                                                                children: errors.city && errors.city.message
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormControl */.NI, {
                                                        isInvalid: errors.phone,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_input_mask_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                mask: "(99) 9999-9999",
                                                                maskChar: "",
                                                                onChange: handlePhoneChange,
                                                                value: phone.value
                                                            }, register("phone", {
                                                                required: "Este campo \xe9 obrigat\xf3rio"
                                                            })), {
                                                                children: function() {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                                                        type: "tel",
                                                                        placeholder: "Telefone",
                                                                        name: "phone"
                                                                    });
                                                                }
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormErrorMessage */.J1, {
                                                                children: errors.phone && errors.phone.message
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormControl */.NI, {
                                                        isInvalid: errors.cellphone,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_input_mask_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                mask: "(99) 9 9999-9999",
                                                                maskChar: "",
                                                                onChange: handleCelularChange,
                                                                value: cellphoneRef.value
                                                            }, register("cellphone", {
                                                                required: "Este campo \xe9 obrigat\xf3rio"
                                                            })), {
                                                                children: function() {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                                                        type: "tel",
                                                                        placeholder: "Celular",
                                                                        name: "cellphone"
                                                                    });
                                                                }
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormErrorMessage */.J1, {
                                                                children: errors.cellphone && errors.cellphone.message
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormControl */.NI, {
                                                        isInvalid: errors.grass,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(select_dist_index_esm/* Select */.Ph, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("grass", {
                                                                required: "Este campo \xe9 obrigat\xf3rio"
                                                            })), {
                                                                placeholder: "Tipo da Grama",
                                                                children: products.map(function(item) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: item.label,
                                                                        children: item.label
                                                                    }, item.label);
                                                                })
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormErrorMessage */.J1, {
                                                                children: errors.grass && errors.grass.message
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormControl */.NI, {
                                                        isInvalid: errors.quantity,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("quantity", {
                                                                required: "Este campo \xe9 obrigat\xf3rio"
                                                            })), {
                                                                type: "number",
                                                                placeholder: "Quantidade (em m2)"
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormErrorMessage */.J1, {
                                                                children: errors.quantity && errors.quantity.message
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormControl */.NI, {
                                                        isInvalid: errors.purpose_of_use,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_dist_index_esm/* Select */.Ph, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("purpose_of_use", {
                                                                required: "Este campo \xe9 obrigat\xf3rio"
                                                            })), {
                                                                placeholder: "Finalidade de Utiliza\xe7\xe3o",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "",
                                                                        children: "(escolha a finalidade de utiliza\xe7\xe3o)"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "Jardim",
                                                                        children: "Jardim"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "Campo de Futebol",
                                                                        children: "Campo de Futebol"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "Ch\xe1cara",
                                                                        children: "Ch\xe1cara"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "Condom\xednio",
                                                                        children: "Condom\xednio"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "Talude",
                                                                        children: "Talude"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "Obras P\xfablicas",
                                                                        children: "Obras P\xfablicas"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "Obras Privadas",
                                                                        children: "Obras Privada"
                                                                    })
                                                                ]
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormErrorMessage */.J1, {
                                                                children: errors.purpose_of_use && errors.purpose_of_use.message
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormControl */.NI, {
                                                        isInvalid: errors.met_us,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_dist_index_esm/* Select */.Ph, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("met_us")), {
                                                                placeholder: "Como chegou at\xe9 nosso site?",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "N\xe3o selecionado",
                                                                        children: "N\xe3o selecionado"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "Google",
                                                                        children: "Google"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "Bing",
                                                                        children: "Bing"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "Facebook",
                                                                        children: "Facebook"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "MercadoLivre",
                                                                        children: "MercadoLivre"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "OLX",
                                                                        children: "OLX"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "Outros",
                                                                        children: "Outros"
                                                                    })
                                                                ]
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormErrorMessage */.J1, {
                                                                children: errors.met_us && errors.met_us.message
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormControl */.NI, {
                                                        isInvalid: errors.additional_services,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_dist_index_esm/* Select */.Ph, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("additional_services")), {
                                                                placeholder: "Servi\xe7os adicionais",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "N\xe3o selecionado",
                                                                        children: "N\xe3o selecionado"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "Execu\xe7\xe3o do Plantio",
                                                                        children: "Execu\xe7\xe3o de Plantio"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "Execu\xe7\xe3o do Plantio",
                                                                        children: "Execu\xe7\xe3o de Plantio + Limpeza"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "Execu\xe7\xe3o do Plantio + Cobertura",
                                                                        children: "Execu\xe7\xe3o do Plantio + Cobertura"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "Execu\xe7\xe3o do Plantio + Limpeza + Cobertura",
                                                                        children: "Execu\xe7\xe3o do Plantio + Limpeza + Cobertura"
                                                                    })
                                                                ]
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormErrorMessage */.J1, {
                                                                children: errors.additional_services && errors.additional_services.message
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormControl */.NI, {
                                                        isInvalid: errors.additional_products,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_dist_index_esm/* Select */.Ph, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("additional_products")), {
                                                                placeholder: "Produtos adicionais",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: "N\xe3o selecionado",
                                                                        children: "N\xe3o selecionado"
                                                                    }),
                                                                    aditionalProducts.map(function(item) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: item.label,
                                                                            children: item.label
                                                                        }, item.label);
                                                                    })
                                                                ]
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormErrorMessage */.J1, {
                                                                children: errors.additional_products && errors.additional_products.message
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormControl */.NI, {
                                                isInvalid: errors.mensagem,
                                                mt: "24px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(textarea_dist_index_esm/* Textarea */.g, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("message")), {
                                                        placeholder: "Mensagem",
                                                        resize: "none"
                                                    })),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormErrorMessage */.J1, {
                                                        children: errors.message && errors.message.message
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormControl */.NI, {
                                                mt: "24px",
                                                isInvalid: !isValid(),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormLabel */.lX, {
                                                        children: question
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                                        type: "text",
                                                        placeholder: "Digite aqui a resposta",
                                                        onChange: function(event) {
                                                            return reply(event.target.value);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormErrorMessage */.J1, {
                                                        children: "Por favor, responda a quest\xe3o acima."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Button */.zx, {
                                                disabled: !isValid() || loading,
                                                shape: "rounded",
                                                children: [
                                                    "Enviar Or\xe7amento ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_esm/* ArrowForwardIcon */.mr, {
                                                        w: 4,
                                                        h: 4
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* About */.CL, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                                children: "Comprar grama para ".concat(seo === null || seo === void 0 ? void 0 : seo.local, " ").concat(seo === null || seo === void 0 ? void 0 : seo.uf, " ")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextContent */.D7, {
                                                children: [
                                                    "Aqui voc\xea encontra gramas com melhor pre\xe7o m\xb2 para entrega em",
                                                    " ",
                                                    seo === null || seo === void 0 ? void 0 : seo.local,
                                                    " ",
                                                    seo === null || seo === void 0 ? void 0 : seo.uf,
                                                    " . Estamos localizados pr\xf3ximo de Angatuba SP, somos fornecedores atacadistas e trabalhamos com quantidade m\xednima de 500 m\xb2 (seja para entrega ou retirada)."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                                children: "Qual o melhor pre\xe7o para ".concat(seo === null || seo === void 0 ? void 0 : seo.local, " ").concat(seo === null || seo === void 0 ? void 0 : seo.uf, " ?")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextContent */.D7, {
                                                children: [
                                                    "Para receber seu or\xe7amento de grama para ",
                                                    seo === null || seo === void 0 ? void 0 : seo.local,
                                                    " ",
                                                    seo === null || seo === void 0 ? void 0 : seo.uf,
                                                    " , preencha todos os campos do",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: " formul\xe1rio acima"
                                                    }),
                                                    " e aguarde prazo m\xe1ximo de 24 horas para resposta em seu e-mail ou para um retorno ainda mais r\xe1pido, basta clicar em nosso",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "https://api.whatsapp.com/send/?phone=5511996172172&type=phone_number&app_absent=0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: " Whatsapp"
                                                        })
                                                    }),
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                                children: "Tipos de grama para ".concat(seo === null || seo === void 0 ? void 0 : seo.local, " ").concat(seo === null || seo === void 0 ? void 0 : seo.uf)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TextContent */.D7, {
                                                children: "Trabalhamos com os seguintes tipos de gramas (consulte disponibilidade e pre\xe7os): esmeralda, esmeralda premium, batatais, batatais plus, s\xe3o carlos, s\xe3o carlos plus, bermuda tifton, bermuda celebration, grama coreana e santo agostinho."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ImageContainer */.mo, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "https://admin.centraldagrama.com/wp-content/uploads/2024/04/entrega-imediata-comprar-grama.webp",
                                                    alt: "compre gramas com entrega imediata",
                                                    title: "Entrega imediata em menos de 24 horas para cidades pr\xf3ximas.",
                                                    layout: "fill",
                                                    objectFit: "cover"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                                children: "Qual grama comprar?"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextContent */.D7, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: " Esmeralda e Esmeralda Premium"
                                                    }),
                                                    ": Jardim aberto, beira de piscina, taludes, minicampos, ch\xe1caras e condom\xednios",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: " Batatais, Batatais Plus"
                                                    }),
                                                    ": Beiras de rodovia, obras p\xfablicas, taludes, plat\xf4s e aterros, pastagem, s\xedtios e locais r\xfasticos",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: "Bermuda Tifton"
                                                    }),
                                                    ", Celebration e Coreana: Campos de futebol, campos de golf, campos esportivos em geral e projetos paisag\xedsticos.",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: "S\xe3o Carlos, S\xe3o Carlos Plus e Santo Agostinho"
                                                    }),
                                                    ": Jardins sombreados, pra\xe7as, pomares, resorts e casas de campo e litoral"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                                children: "Ap\xf3s comprar grama para ".concat(seo === null || seo === void 0 ? void 0 : seo.local, " ").concat(seo === null || seo === void 0 ? void 0 : seo.uf, ", posso plantar a grama em no m\xe1ximo quantos dias?")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TextContent */.D7, {
                                                children: "O recomend\xe1vel \xe9 plantar a grama o quanto antes, mas ela pode ficar armazenada at\xe9 15 dias ap\xf3s descarga, em local aberto e arejado. Fazemos entregas no Nordeste por exemplo e s\xf3 para chegar o caminh\xe3o leva em m\xe9dia 7 dias \xfateis, ainda sim a grama sobrevive."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ImageContainer */.mo, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "https://admin.centraldagrama.com/wp-content/uploads/2024/04/esmeralda-premium-comprar.webp",
                                                    alt: "comprar grama esmeralda premium",
                                                    title: "Comprar grama esmeralda premium para ".concat(seo === null || seo === void 0 ? void 0 : seo.local, " - ").concat(seo === null || seo === void 0 ? void 0 : seo.uf),
                                                    layout: "fill",
                                                    objectFit: "cover"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                                children: "Qual o prazo de retorno para o or\xe7amento da grama para ".concat(seo === null || seo === void 0 ? void 0 : seo.local, " ").concat(seo === null || seo === void 0 ? void 0 : seo.uf, " ?")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TextContent */.D7, {
                                                children: "Por telefone \xe9 imediato, pelo Whatsapp pode levar algumas horas (dependendo do hor\xe1rio) e por e-mail 24 horas \xfateis. Para agilizar o or\xe7amento, pedimos para que informe o tipo de grama, quantidade em metros quadrados e o local de entrega."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                                children: "Tem quantidade m\xednima para entrega em ".concat(seo === null || seo === void 0 ? void 0 : seo.local, " ").concat(seo === null || seo === void 0 ? void 0 : seo.uf, " ?")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TextContent */.D7, {
                                                children: "Sim, somos fornecedores atacadistas. O m\xednimo no atacado s\xe3o 500 m\xb2, isso vale tanto para entrega como para retirada tamb\xe9m. Metragens menores voc\xea pode conseguir no varejo com floriculturas, casas de paisagismo e jardinagem, gardens ou CEASA/CEAGESP mais pr\xf3ximo."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ImageContainer */.mo, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "https://admin.centraldagrama.com/wp-content/uploads/2024/04/grama-placas-esmeralda-premium.webp",
                                                    alt: "comprar grama esmeralda premium",
                                                    title: "Grama Esmeralda com melhor pre\xe7o para ".concat(seo === null || seo === void 0 ? void 0 : seo.local, " - ").concat(seo === null || seo === void 0 ? void 0 : seo.uf),
                                                    layout: "fill",
                                                    objectFit: "cover"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                                children: "Qual prazo de entrega para ".concat(seo === null || seo === void 0 ? void 0 : seo.local, " ").concat(seo === null || seo === void 0 ? void 0 : seo.uf, " ?")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TextContent */.D7, {
                                                children: "O prazo de entrega come\xe7a a contar a partir da formaliza\xe7\xe3o do pedido e emiss\xe3o da nota fiscal e pode variar dependendo da localidade de compra, variando de 2 a no m\xe1ximo 10 dias \xfateis."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TableContainer */.xJ, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Table */.iA, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TableTr */.wn, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TableTh */.c_, {
                                                                        scope: "col",
                                                                        children: "Estado"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TableTh */.c_, {
                                                                        scope: "col",
                                                                        children: "Prazo de entrega"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TableTr */.wn, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TableTh */.c_, {
                                                                            scope: "row",
                                                                            children: "SP e PR"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TableTd */.ge, {
                                                                            children: "2 \xe0 3 dias \xfateis"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TableTr */.wn, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TableTh */.c_, {
                                                                            scope: "row",
                                                                            children: "SC, MG, RJ, ES e MS"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TableTd */.ge, {
                                                                            children: "3 \xe0 5 dias \xfateis"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TableTr */.wn, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TableTh */.c_, {
                                                                            scope: "row",
                                                                            children: "MT, RS, GO, DF e BA"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TableTd */.ge, {
                                                                            children: "5 \xe0 7 dias \xfateis"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TableTr */.wn, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TableTh */.c_, {
                                                                            scope: "row",
                                                                            children: [
                                                                                "TO, MA, PI, PA, AP, RR, AM,",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                                " AC, RO, CE, SE, AL, PE, PB, RN"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TableTd */.ge, {
                                                                            children: "7 \xe0 10 dias \xfateis"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tfoot", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TableTr */.wn, {})
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                                children: " Sou de ".concat(seo === null || seo === void 0 ? void 0 : seo.local, " ").concat(seo === null || seo === void 0 ? void 0 : seo.uf, ", onde posso retirar a grama? ")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TextContent */.D7, {
                                                children: "Temos v\xe1rios grameiros e v\xe1rios pontos de coleta. Para facilitar, passamos o endere\xe7o do posto de combust\xedvel que fica no km 159 da Rodovia Raposo Tavares em Itapetininga SP. Com a data de retirada combinada, enviamos a localiza\xe7\xe3o no dia do carregamento."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                                children: "Quais s\xe3o as nossas condi\xe7\xf5es de pagamento?"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TextContent */.D7, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: "Boleto \xe0 vista, dep\xf3sito ou transfer\xeancia banc\xe1ria. Tamb\xe9m temos PIX e parcelamos no cart\xe3o at\xe9 em 12x + taxas. A compra \xe9 100% segura, utilizamos o PicPay, PagBank, PayPal ou Mercado Pago."
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                                children: "Tags relacionadas:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextLink */.hh, {
                                                href: "https://centraldagrama.com/comprar-grama/".concat(province, "/").concat(city),
                                                title: "comprar grama ".concat(city, " ").concat(province),
                                                children: [
                                                    "comprar grama ",
                                                    seo === null || seo === void 0 ? void 0 : seo.local,
                                                    " ",
                                                    seo === null || seo === void 0 ? void 0 : seo.uf
                                                ]
                                            }),
                                            ",",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextLink */.hh, {
                                                href: "https://centraldagrama.com/comprar-grama/".concat(province, "/").concat(city),
                                                title: "pre\xe7o de grama ".concat(city, " ").concat(province),
                                                children: [
                                                    "pre\xe7o de grama ",
                                                    seo === null || seo === void 0 ? void 0 : seo.local,
                                                    " ",
                                                    seo === null || seo === void 0 ? void 0 : seo.uf
                                                ]
                                            }),
                                            ",",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextLink */.hh, {
                                                href: "https://centraldagrama.com/comprar-grama/".concat(province, "/").concat(city),
                                                title: "comprar grama esmeralda pre\xe7o m\xb2 ".concat(city, " ").concat(province),
                                                children: [
                                                    "comprar grama esmeralda pre\xe7o m\xb2 ",
                                                    seo === null || seo === void 0 ? void 0 : seo.local,
                                                    " ",
                                                    seo === null || seo === void 0 ? void 0 : seo.uf
                                                ]
                                            }),
                                            ",",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextLink */.hh, {
                                                href: "https://centraldagrama.com/comprar-grama/".concat(province, "/").concat(city),
                                                title: "comprar grama batatais em pre\xe7o m\xb2 ".concat(city, " ").concat(province, " "),
                                                children: [
                                                    "comprar grama batatais em pre\xe7o m\xb2 ",
                                                    seo === null || seo === void 0 ? void 0 : seo.local,
                                                    " ",
                                                    seo === null || seo === void 0 ? void 0 : seo.uf
                                                ]
                                            }),
                                            ",",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextLink */.hh, {
                                                href: "https://centraldagrama.com/comprar-grama/".concat(province, "/").concat(city),
                                                title: "comprar grama s\xe3o carlos pre\xe7o m\xb2 ".concat(city, " ").concat(province, " "),
                                                children: [
                                                    "comprar grama s\xe3o carlos pre\xe7o m\xb2 ",
                                                    seo === null || seo === void 0 ? void 0 : seo.local,
                                                    " ",
                                                    seo === null || seo === void 0 ? void 0 : seo.uf
                                                ]
                                            }),
                                            ",",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextLink */.hh, {
                                                href: "https://centraldagrama.com/comprar-grama/{province}/${city}",
                                                title: "comprar grama bermuda pre\xe7o m\xb2 sorocaba sp ".concat(city, " ").concat(province),
                                                children: [
                                                    "comprar grama bermuda pre\xe7o m\xb2 ",
                                                    seo === null || seo === void 0 ? void 0 : seo.local,
                                                    " ",
                                                    seo === null || seo === void 0 ? void 0 : seo.uf
                                                ]
                                            }),
                                            ",",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextLink */.hh, {
                                                href: "https://centraldagrama.com/comprar-grama/{province}/${city}",
                                                title: "comprar grama coreana pre\xe7o m\xb2 ".concat(city, " ").concat(province),
                                                children: [
                                                    "comprar grama coreana pre\xe7o m\xb2 ",
                                                    seo === null || seo === void 0 ? void 0 : seo.local,
                                                    " ",
                                                    seo === null || seo === void 0 ? void 0 : seo.uf
                                                ]
                                            }),
                                            ",",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextLink */.hh, {
                                                href: "https://centraldagrama.com/comprar-grama/sp/sorocaba",
                                                title: "comprar grama santo agostinho pre\xe7o m\xb2 ".concat(city, " ").concat(province),
                                                children: [
                                                    "comprar grama santo agostinho pre\xe7o m\xb2 ",
                                                    seo === null || seo === void 0 ? void 0 : seo.local,
                                                    " ",
                                                    seo === null || seo === void 0 ? void 0 : seo.uf
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _city_page = (Contato);


/***/ }),

/***/ 3194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ About; },
/* harmony export */   "D7": function() { return /* binding */ TextContent; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "O6": function() { return /* binding */ Right; },
/* harmony export */   "c_": function() { return /* binding */ TableTh; },
/* harmony export */   "ck": function() { return /* binding */ Item; },
/* harmony export */   "de": function() { return /* binding */ WrapperItemList; },
/* harmony export */   "dv": function() { return /* binding */ Left; },
/* harmony export */   "ge": function() { return /* binding */ TableTd; },
/* harmony export */   "hh": function() { return /* binding */ TextLink; },
/* harmony export */   "iA": function() { return /* binding */ Table; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "l0": function() { return /* binding */ Form; },
/* harmony export */   "mo": function() { return /* binding */ ImageContainer; },
/* harmony export */   "rj": function() { return /* binding */ Grid; },
/* harmony export */   "sr": function() { return /* binding */ ItemList; },
/* harmony export */   "wn": function() { return /* binding */ TableTr; },
/* harmony export */   "xJ": function() { return /* binding */ TableContainer; },
/* harmony export */   "xv": function() { return /* binding */ Text; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony exports Map, IconWrap, Label */
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7573);
/* harmony import */ var styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4767);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8641);
/* harmony import */ var components_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8859);




var Map = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    width: "100%",
    height: 200,
    marginBottom: 50,
    background: "#A7C2B9",
    "@lg": {
        height: 350,
        marginBottom: 112
    }
});
var Flex = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    "@lg": {
        display: "flex",
        flexDirection: "column",
        alignContent: "center"
    }
});
var Left = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    flex: 1,
    marginBottom: 50,
    "@lg": {
        marginBottom: 0
    }
});
var Form = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("form", {
    marginTop: 15,
    "@md": {
        marginTop: 32
    }
});
var Grid = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Grid */ .rj, {
    gridTemplateColumns: "repeat(1, 1fr)",
    "@md": {
        gridTemplateColumns: "repeat(2, 1fr)"
    }
});
var Right = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("aside", {
    flex: 1,
    "@lg": {
        marginLeft: 94,
        maxWidth: 400
    }
});
var Button = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)(components_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    position: "relative",
    marginTop: 56,
    "& svg": {
        marginLeft: 5,
        marginTop: "-2px"
    }
});
var About = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    padding: 16,
    position: "sticky",
    top: 10,
    borderRadius: 4,
    maxWidth: "100% !important",
    "@lg": {
        padding: 48
    },
    "& h4": {
        fontSize: "28px !important",
        marginBottom: 40
    }
});
var Item = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    display: "flex",
    alignItems: "center",
    "&:not(:last-of-type)": {
        paddingBottom: 35,
        marginBottom: 35,
        borderBottom: "solid 1px",
        borderBottomColor: "$emerald500"
    }
});
var IconWrap = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    width: 60,
    height: 60,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 10,
    borderRadius: "100%",
    background: "$emerald100"
});
var Label = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("p", {
    fontFamily: "$domine",
    fontWeight: "bold",
    fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(14),
    color: "$grey900"
});
var Text = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("p", {
    fontFamily: "$domine",
    fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(14),
    color: "$grey600",
    marginLeft: "auto"
});
var TableContainer = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(22)
});
var TextContent = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("p", {
    fontFamily: "$domine",
    fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(14),
    color: "$grey600",
    marginBottom: (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(22)
});
var TextLink = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("a", {
    fontFamily: "$domine",
    fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(14),
    color: "$grey600",
    textDecoration: "underline"
});
var Title = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("h2", {
    fontSize: "37px !important",
    marginTop: (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(22),
    marginBottom: (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(22)
});
var Table = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("table", {
    borderCollapse: "collapse"
});
var TableTh = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("th", {
    backgroundColor: "#f2f2f2",
    border: "1px solid #ddd",
    padding: (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(8)
});
var TableTd = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("td", {
    border: "1px solid #ddd",
    padding: "8px"
});
var TableTr = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("tr", {
    textAlign: "center"
});
var WrapperItemList = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    maxWidth: "80%",
    margin: "0 auto"
});
var ItemList = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    padding: "15px",
    backgroundColor: "$grey100",
    borderRadius: "8px",
    marginBottom: "10px",
    color: "$black",
    cursor: "pointer",
    "&:hover": {
        opacity: 0.5
    }
});
var ImageContainer = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("figure", {
    position: "relative",
    width: "80%",
    height: 250,
    marginBottom: 22,
    margin: " auto",
    border: "4px solid $white ",
    boxShadow: "0 0 8px rgba(0, 0, 0, 0.6)",
    "@md": {
        width: 550,
        height: 350,
        marginBottom: 22
    }
});


/***/ }),

/***/ 2994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FO": function() { return /* binding */ sendBudget; },
/* harmony export */   "b8": function() { return /* binding */ sendContact; },
/* harmony export */   "gO": function() { return /* binding */ sendOrder; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var services_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9419);



var sendContact = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
        var data;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return services_api__WEBPACK_IMPORTED_MODULE_1__/* .apiContact.post */ .fz.post("501/feedback", payload);
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendContact(payload) {
        return _ref.apply(this, arguments);
    };
}();
var sendBudget = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
        var data;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return services_api__WEBPACK_IMPORTED_MODULE_1__/* .apiContact.post */ .fz.post("573/feedback", payload);
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendBudget(payload) {
        return _ref.apply(this, arguments);
    };
}();
var sendOrder = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
        var data;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return services_api__WEBPACK_IMPORTED_MODULE_1__/* .apiSameOrigin.post */ .Y8.post("/send-mail", payload);
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendOrder(payload) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 3835:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ([
    {
        "nome": "Acre",
        "sigla": "AC"
    },
    {
        "nome": "Alagoas",
        "sigla": "AL"
    },
    {
        "nome": "Amap\xe1",
        "sigla": "AP"
    },
    {
        "nome": "Amazonas",
        "sigla": "AM"
    },
    {
        "nome": "Bahia",
        "sigla": "BA"
    },
    {
        "nome": "Cear\xe1",
        "sigla": "CE"
    },
    {
        "nome": "Distrito Federal",
        "sigla": "DF"
    },
    {
        "nome": "Esp\xedrito Santo",
        "sigla": "ES"
    },
    {
        "nome": "Goi\xe1s",
        "sigla": "GO"
    },
    {
        "nome": "Maranh\xe3o",
        "sigla": "MA"
    },
    {
        "nome": "Mato Grosso",
        "sigla": "MT"
    },
    {
        "nome": "Mato Grosso do Sul",
        "sigla": "MS"
    },
    {
        "nome": "Minas Gerais",
        "sigla": "MG"
    },
    {
        "nome": "Par\xe1",
        "sigla": "PA"
    },
    {
        "nome": "Para\xedba",
        "sigla": "PB"
    },
    {
        "nome": "Paran\xe1",
        "sigla": "PR"
    },
    {
        "nome": "Pernambuco",
        "sigla": "PE"
    },
    {
        "nome": "Piau\xed",
        "sigla": "PI"
    },
    {
        "nome": "Rio de Janeiro",
        "sigla": "RJ"
    },
    {
        "nome": "Rio Grande do Norte",
        "sigla": "RN"
    },
    {
        "nome": "Rio Grande do Sul",
        "sigla": "RS"
    },
    {
        "nome": "Rond\xf4nia",
        "sigla": "RO"
    },
    {
        "nome": "Roraima",
        "sigla": "RR"
    },
    {
        "nome": "Santa Catarina",
        "sigla": "SC"
    },
    {
        "nome": "S\xe3o Paulo",
        "sigla": "SP"
    },
    {
        "nome": "Sergipe",
        "sigla": "SE"
    },
    {
        "nome": "Tocantins",
        "sigla": "TO"
    }
]);


/***/ }),

/***/ 9210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useRecaptcha; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useRecaptcha = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), rightResponse = ref[0], setRightResponse = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), question = ref1[0], setQuestion = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), response = ref2[0], setResponse = ref2[1];
    var isValid = function() {
        return rightResponse === response;
    };
    var generateQuestion = function() {
        var a = Math.floor(Math.random() * 101);
        var b = Math.floor(Math.random() * 101);
        setRightResponse(Number(a + b));
        setQuestion("Qual \xe9 o valor da soma ".concat(a, " + ").concat(b, "?"));
    };
    var reply = function(value) {
        var parsedValue = Number(value);
        setResponse(parsedValue);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        generateQuestion();
    }, []);
    return {
        question: question,
        isValid: isValid,
        reply: reply,
        generateQuestion: generateQuestion
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [753,921,112,434,861,774,888,179], function() { return __webpack_exec__(2126); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);